import Shop from './pages/Shop/store.js'

const jCherry = {
  // チェリー
  key: 'j_cherry',
  uuid: '3d1a1ab3-aa24-4ebe-bfcd-513c9dc6f116',
  prefixTitle: 'ジューシーズ',
  title: 'チェリー',
  title2: 'withアップルベース',
  energy: 51,
  percentage: 'トータル果汁99% りんごストレート果汁90.6%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 1,
  category: 'juicies',
  new: true,
  display: {
    color: '#74001a',
    lightColor: '#f2cdcf',
    descriptions: [
      'りんごのストレート果汁に、濃縮さくらんぼ果汁、りんご還元果汁をミックス。',
      'ふんわりエレガントな香りと、芳醇で甘酸っぱい果汁感。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_cherry.jpg'),
        alt: 'チェリーイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_cherry.png'),
        alt: 'チェリー商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_cherry.png'),
        alt: 'チェリー　商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['りんご果汁、濃縮さくらんぼ果汁、濃縮りんご果汁／香料、酸化防止剤（V.C）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '51kcal'
      }, {
        title: 'たんぱく質',
        content: '0.2g'
      }, {
        title: '脂質',
        content: '0.2g'
      }, {
        title: '炭水化物',
        content: '12.8g'
      }, {
        title: 'ー糖類',
        content: '12.6g'
      }, {
        title: '食塩相当量',
        content: '0.001g'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）90.6%、濃縮さくらんぼ果汁 5.5%、りんご果汁（濃縮還元）3.7%'],
      complex: false
    }],
    unit: '箱'
  }
}

const jPeach = {
  // ピーチ
  key: 'j_peach',
  uuid: '3d1a1ab3-aa24-4ebe-bfcd-513c9dc6f116',
  prefixTitle: 'ジューシーズ',
  title: 'ピーチ',
  title2: 'withアップルベース',
  energy: 46,
  percentage: 'トータル果汁・果肉99% りんごストレート果汁89%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 1,
  category: 'juicies',
  display: {
    color: '#ed7969',
    lightColor: '#ffe5e1',
    descriptions: [
      'りんごのストレート果汁に、ピーチピューレとりんごの還元果汁をミックス。',
      'りんごとピーチの甘さと爽やかな風味が広がります。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_peach.jpg'),
        alt: 'ピーチイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_peach.png'),
        alt: 'ピーチ商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_peach.png'),
        alt: 'ピーチ商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['りんご果汁、ももピューレ、濃縮りんご果汁／酸化防止剤（V.C）、香料'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '47kcal'
      }, {
        title: 'たんぱく質',
        content: '0.1g'
      }, {
        title: '脂質',
        content: '0.1g'
      }, {
        title: '炭水化物',
        content: '11.4g'
      }, {
        title: 'ー糖類',
        content: '11.3g'
      }, {
        title: '食塩相当量',
        content: '0.005g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁・果肉99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）89%、ももピューレ6%、りんご果汁（濃縮還元）4%'],
      complex: false
    }],
    unit: '箱'
  }
}

const jApple = {
  // アップル
  key: 'j_apple',
  uuid: '1780adf6-3135-4d61-a0f1-b7480f843f8d',
  prefixTitle: 'ジューシーズ',
  title: 'アップル',
  energy: 48,
  percentage: 'トータル果汁99% りんごストレート果汁96%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 2,
  category: 'juicies',
  display: {
    color: '#ea372a',
    lightColor: '#ffc9cb',
    descriptions: [
      'トータル99％のりんご果汁を使った',
      'りんごを存分に楽しんでいただける商品です。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_apple.jpg'),
        alt: 'アップルイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_apple.png'),
        alt: 'アップル商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_apple.png'),
        alt: 'アップル商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['りんご果汁 ／香料、酸化防止剤（V.C）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '48kcal'
      }, {
        title: 'たんぱく質',
        content: '0.1g'
      }, {
        title: '脂質',
        content: '0.1g'
      }, {
        title: '炭水化物',
        content: '11.8g'
      }, {
        title: 'ー糖類',
        content: '11.7g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）96％、りんご果汁（濃縮還元）3%'],
      complex: false
    }],
    unit: '箱'
  }
}

const jTropical = {
  // トロピカル
  key: 'j_tropical',
  uuid: 'f7475b22-24a4-4944-832f-97c6e6697289',
  prefixTitle: 'ジューシーズ',
  title: 'トロピカル',
  energy: 46,
  percentage: 'トータル果汁99% りんごストレート果汁95%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 3,
  category: 'juicies',
  display: {
    color: '#00b2e8',
    lightColor: '#cdf0f9',
    descriptions: [
      'りんごのストレート果汁に、オレンジ、パインアップル、パッションフルーツ、りんご、マンゴーの還元果汁をミックス。',
      'トロピカル風味のフルーツ感あふれるテイストです。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_tropical.jpg'),
        alt: 'トロピカルイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_tropical.png'),
        alt: 'トロピカル商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_tropical.png'),
        alt: 'トロピカル商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['果汁（りんご、オレンジ、パインアップル、パッションフルーツ、マンゴー）／香料、酸化防止剤（V.C）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '46kcal'
      }, {
        title: 'たんぱく質',
        content: '0.2g'
      }, {
        title: '脂質',
        content: '0.1g'
      }, {
        title: '炭水化物',
        content: '11.7g'
      }, {
        title: 'ー糖類',
        content: '11.7g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）95%、果汁（濃縮還元）4％（オレンジ、パインアップル、パッションフルーツ、りんご、マンゴー）'],
      complex: false
    }],
    unit: '箱'
  }
}

const jOrange = {
  // オレンジ
  key: 'j_orange',
  uuid: 'ca854efe-5390-47e1-861c-06868be19737',
  prefixTitle: 'ジューシーズ',
  title: 'オレンジ',
  title2: 'withアップルベース',
  energy: 46,
  percentage: 'トータル果汁99% りんごストレート果汁94%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 4,
  category: 'juicies',
  display: {
    color: '#f79d32',
    lightColor: '#fcebaa',
    descriptions: [
      'りんごのストレート果汁に、オレンジの還元果汁をミックス。',
      'りんごとオレンジの甘さと爽やかな風味が広がります。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_orange.jpg'),
        alt: 'オレンジイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_orange.png'),
        alt: 'オレンジ商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_orange.png'),
        alt: 'オレンジ商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['果汁（りんご、オレンジ）／香料、酸化防止剤（V.C）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '46kcal'
      }, {
        title: 'たんぱく質',
        content: '0.2g'
      }, {
        title: '脂質',
        content: '0.1g'
      }, {
        title: '炭水化物',
        content: '11.8g'
      }, {
        title: 'ー糖類',
        content: '11.8g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）94%、果汁（濃縮還元）5％（オレンジ）'],
      complex: false
    }],
    unit: '箱'
  }
}

const jLemonade = {
  // レモネード
  key: 'j_lemonade',
  uuid: '181df3e1-81f7-48fa-8125-c36c09ec3be8',
  prefixTitle: 'ジューシーズ',
  title: 'レモネード',
  title2: 'withアップルベース',
  energy: 47,
  percentage: 'トータル果汁99% りんごストレート果汁96%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 5,
  category: 'juicies',
  display: {
    color: '#79b703',
    lightColor: '#d7efb6',
    descriptions: [
      'りんごのストレート果汁に、りんご、レモンの還元果汁をミックス。',
      'さっぱり爽やかなテイストです'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_lemonade.jpg'),
        alt: 'レモネードイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_lemonade.png'),
        alt: 'レモネード商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_lemonade.png'),
        alt: 'レモネード商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['果汁（りんご、レモン）／香料、酸化防止剤（V.C）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '47kcal'
      }, {
        title: 'たんぱく質',
        content: '0.1g'
      }, {
        title: '脂質',
        content: '0.1g'
      }, {
        title: '炭水化物',
        content: '11.7g'
      }, {
        title: 'ー糖類',
        content: '11.7g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）96%、果汁（濃縮還元）3%（りんご、レモン）'],
      complex: false
    }],
    unit: '箱'
  }
}

const jWildberry = {
  // ワイルドベリー
  key: 'j_wildberry',
  uuid: '5e388832-92f2-46bf-85df-ecdd0aa21a75',
  prefixTitle: 'ジューシーズ',
  title: 'ワイルドベリー',
  title2: 'withアップルベース',
  energy: 47,
  percentage: 'トータル果汁99% りんごストレート果汁96%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 6,
  category: 'juicies',
  display: {
    color: '#d10a74',
    lightColor: '#f5d2de',
    descriptions: [
      'りんごのストレート果汁にボイセンベリー、カシスの還元果汁をミックス。',
      '甘さと酸味がミックスされた爽やかな味わいです。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_j_wildberry.jpg'),
        alt: 'ワイルドベリーイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_j_wildberry.png'),
        alt: 'ワイルドベリー商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_j_wildberry.png'),
        alt: 'ワイルドベリー商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['果汁（りんご、ボイセンベリー、カシス）／香料、酸化防止剤（V.C）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '47kcal'
      }, {
        title: 'たんぱく質',
        content: '0.1g'
      }, {
        title: '脂質',
        content: '0.1g'
      }, {
        title: '炭水化物',
        content: '11.4g'
      }, {
        title: 'ー糖類',
        content: '11.7g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: '糖類は果汁に由来するものです。'
      }],
      complex: true
    }, {
      titles: ['果汁99％の内訳'],
      contents: ['ニュージーランド産りんご果汁（ストレート）96%、果汁（濃縮還元）3％（ボイセンベリー、カシス）'],
      complex: false
    }],
    unit: '箱'
  }
}

const cStrawberry = {
  // ココナッツストロベリー
  key: 'c_strawberry',
  uuid: '5e896c35-51e2-433f-9ca1-eb527953354c',
  prefixTitle: 'ココナッツジューシーズ',
  title: 'ストロベリー',
  title2: 'withアップルベース',
  energy: 46,
  percentage: 'りんごストレート果汁88%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 7,
  category: 'coconuts',
  display: {
    color: '#ee7c57',
    lightColor: '#f0bba8',
    descriptions: [
      'りんごのストレート果汁にココナッツクリーム、ストロベリーピューレをミックス。',
      'ストロベリーの甘さと酸味、ココナッツの風味が楽しめます。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_c_strawberry.jpg'),
        alt: 'ココナッツストロベリーイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_c_strawberry.png'),
        alt: 'ココナッツストロベリー商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_c_strawberry.png'),
        alt: 'ココナッツストロベリー商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['りんご果汁、ストロベリーピューレ、ココナッツクリーム／香料、安定剤（増粘多糖類）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '46kcal'
      }, {
        title: 'たんぱく質',
        content: '0.2g'
      }, {
        title: '脂質',
        content: '0.9g'
      }, {
        title: '炭水化物',
        content: '11.4g'
      }, {
        title: 'ー糖類',
        content: '9.4g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: '',
        content: 'この表示値は、目安です。'
      }],
      complex: true
    }],
    unit: '箱'
  }
}

const cPine = {
  // ココナッツパイン
  key: 'c_pine',
  uuid: 'a0bed630-1a4b-4239-8684-c24acbd71e02',
  prefixTitle: 'ココナッツジューシーズ',
  title: 'パインアップル',
  title2: 'withアップルベース',
  energy: 46,
  percentage: 'りんごストレート果汁90%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 8,
  category: 'coconuts',
  display: {
    color: '#39b059',
    lightColor: '#bcecc9',
    descriptions: [
      'りんごのストレート果汁にココナッツクリーム、パインアップルの還元果汁をミックス。',
      'パインの爽やかさとココナッツの風味が楽しめます。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_c_pineapple.jpg'),
        alt: 'ココナッツパインイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_c_pineapple.png'),
        alt: 'ココナッツパインアップル商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_c_pineapple.png'),
        alt: 'ココナッツパイン商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['果汁（りんご、パインアップル）、ココナッツクリーム／香料、安定剤（増粘多糖類）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '46kcal'
      }, {
        title: 'たんぱく質',
        content: '0.2g'
      }, {
        title: '脂質',
        content: '0.6g'
      }, {
        title: '炭水化物',
        content: '11.4g'
      }, {
        title: 'ー糖類',
        content: '9.4g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: 'この表示値は目安です。'
      }],
      complex: true
    }],
    unit: '箱'
  }
}

const cMango = {
  // ココナッツマンゴー
  key: 'c_mango',
  uuid: '45f5f8b2-9a7e-4a24-96a3-5a4dbed05d0d',
  prefixTitle: 'ココナッツジューシーズ',
  title: 'マンゴー',
  title2: 'withアップルベース',
  energy: 46,
  percentage: 'りんごストレート果汁88%',
  contents: '１箱 （25本入り）',
  quantity: '1種類\n25本入',
  price: 5400,
  num: null,
  sortOrder: 9,
  category: 'coconuts',
  display: {
    color: '#f08a53',
    lightColor: '#f2c7ad',
    descriptions: [
      'りんごのストレート果汁にココナッツクリーム、マンゴーピューレをミックス。',
      'マンゴーの甘さとほのかに香るココナッツの風味を楽しめます。'
    ],
    contensAppendices: [
      '（１本あたり200円）'
    ],
    image: {
      main: {
        src: require('@/../static/images/shop/image_c_mango.jpg'),
        alt: 'ココナッツマンゴーイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/item_c_mango.png'),
        alt: 'ココナッツマンゴー商品画像'
      },
      itemImg: {
        src: require('@/../static/images/item_c_mango.png'),
        alt: 'ココナッツマンゴー商品画像'
      }
    },
    ingredients: [{
      titles: ['種類別'],
      contents: ['氷菓'],
      complex: false
    }, {
      titles: ['原材料名'],
      contents: ['りんご果汁、マンゴーピューレ、ココナッツクリーム／香料、安定剤（増粘多糖類）'],
      complex: false
    }, {
      titles: ['内容量'],
      contents: ['105ml'],
      complex: false
    }, {
      titles: ['栄養成分表示', '１本105mlあたり'],
      contents: [{
        title: 'エネルギー',
        content: '45kcal'
      }, {
        title: 'たんぱく質',
        content: '0.2g'
      }, {
        title: '脂質',
        content: '0.9g'
      }, {
        title: '炭水化物',
        content: '9.8g'
      }, {
        title: '食塩相当量',
        content: '0.01g'
      }, {
        title: 'ビタミンC',
        content: '29mg'
      }, {
        title: '',
        content: 'この表示値は目安です。'
      }],
      complex: true
    }],
    unit: '箱'
  }
}

const setJuicies = {
  // カラフルジューシーズセット
  key: 'set_juicies',
  uuid: '16349fa4-a449-43e9-aaa1-b47048ee94f6',
  prefixTitle: 'ジューシーズ各1本',
  title: 'カラフルジューシーズ',
  title2: 'セット',
  contents: '１セット （6本入り）',
  quantity: '6種類×\n各1本',
  price: 1800,
  num: null,
  sortOrder: 10,
  category: 'specials',
  display: {
    color: '#3c2108',
    descriptions: [
      'カラフルジューシーズ各１本入りの6本セット',
      '後味すっきり！',
      'フルーツ本来の甘みが楽しめます'
    ],
    contensAppendices: [],
    image: {
      main: {
        src: require('@/../static/images/shop/image_set_juicies.jpg'),
        alt: 'カラフルジューシーズセットイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/shop/set_juicies.png'),
        alt: 'カラフルジューシーズセット画像'
      }
    },
    ingredients: [],
    unit: 'セット'
  }
}

const setCoconuts = {
  // ココナッツジューシーズセット
  key: 'set_coconuts',
  uuid: 'b1b9fda2-281f-49fe-bec4-25747d7a8e61',
  prefixTitle: 'ココナッツ各2本',
  title: 'ココナッツジューシーズ',
  title2: 'セット',
  contents: '１セット （6本入り）',
  quantity: '3種類×\n各2本',
  price: 1800,
  num: null,
  sortOrder: 11,
  category: 'specials',
  display: {
    color: '#3c2108',
    descriptions: [
      'ココナッツジューシーズ各2本入りの6本セット',
      'ジューシーでなめらか',
      'ココナッツの風味がほのかに香ります'
    ],
    contensAppendices: [],
    image: {
      main: {
        src: require('@/../static/images/shop/image_set_coconuts.jpg'),
        alt: 'ココナッツジューシーズセットイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/shop/set_coconuts.png'),
        alt: 'ココナッツジューシーズセット画像'
      }
    },
    ingredients: [],
    unit: 'セット'
  }
}

const setOtameshi = {
  // おためしセット
  key: 'set_otameshi',
  uuid: 'f6c162fa-eacf-4f7d-81af-4b4ba2fcd77c',
  prefixTitle: '全種類各１本',
  title: '迷ったらこれ！',
  title2: 'おためしセット',
  contents: '１セット （9本入り）',
  quantity: '9種類×\n各1本',
  price: 2200,
  num: null,
  sortOrder: 12,
  category: 'specials',
  display: {
    color: '#3c2108',
    descriptions: [
      '各フレーバー１本入り！8種類のフレーバーを全部楽しめる',
      'おためしセット♪',
      'プレゼントやパーティーにもぴったり!'
    ],
    contensAppendices: [],
    image: {
      main: {
        src: require('@/../static/images/shop/image_set_otameshi.jpg'),
        alt: 'お試しセットイメージ'
      },
      thumbnail: {
        src: require('@/../static/images/shop/set_otameshi.png'),
        alt: 'お試しセット画像'
      }
    },
    ingredients: [],
    unit: 'セット'
  }
}
export default {
  namespaced: true,
  modules: {
    shop: Shop
  },
  state () {
    return {
      items: [
        jCherry,
        jPeach,
        jApple,
        jTropical,
        jOrange,
        jLemonade,
        jWildberry,
        cStrawberry,
        cPine,
        cMango,
        setJuicies,
        setCoconuts,
        setOtameshi
      ]
    }
  },
  getters: {
    items (state) {
      return state.items
    }
  },
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/app/store.js